import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable()
export class DireccionesWsService {
    [x: string]: any;

    public url;
    public identity;
    public token;
    constructor(private _http: Http) {
        this.url = GLOBAL.url;
    }

    getDatosDireccion(id) {
        let params = {
            id: id
        };
        let headers = new Headers({
            'Content-Type': 'application/json'
            //,'Authorization': sessionStorage.getItem("token-domCloud")
        })
        return this._http.post(this.url + 'get/infoDir', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

}